module.exports = "<p>\n  Your payment has been successfully processed !\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/payment/complete-payment/complete-payment.component.html
// module id = ./src/app/shared/payment/complete-payment/complete-payment.component.html
// module chunks = main